import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Interactive } from "./Interactive.js";
import { TooltipTrigger } from "./TooltipTrigger.js";
const Clickable = forwardRef((props, ref) => {
  const { children, disabled, href, tagName = href ? "a" : "div", tooltip, tooltipDelay, tooltipSide, useTooltipAsLabel, onClick, ...otherProps } = props;
  const interactiveElement = jsx(Interactive, { ref, "aria-disabled": !!disabled, disabled, href: !disabled ? href : void 0, tabIndex: disabled ? -1 : 0, tagName, onClick: (e) => onClick && !disabled && onClick(e), ...otherProps, children });
  if (tooltip) {
    return jsx(TooltipTrigger, { content: tooltip, side: tooltipSide, delay: tooltipDelay, useTooltipAsLabel, children: interactiveElement });
  }
  return interactiveElement;
});
Clickable.displayName = "Clickable";
export {
  Clickable
};
